import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { class: "unit-label" }
const _hoisted_4 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "unit-label" }
const _hoisted_9 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_10 = ["innerHTML"]

import { computed } from "vue";

interface Props {
  horizontal: boolean;
  currentColormap: (x: number) => string;
  colorMap: string;
  startValue: number;
  endValue: number;
  moleculeLabel: string; // can contain html
  cbarScale: number;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MapColorbarWrap',
  props: {
    horizontal: { type: Boolean },
    currentColormap: { type: Function },
    colorMap: {},
    startValue: {},
    endValue: {},
    moleculeLabel: {},
    cbarScale: {}
  },
  setup(__props: any) {

const props = __props;

const scalePower = computed(() => {
  const p = Math.log10(props.cbarScale);
  return Number.isFinite(p) ? p : 0;
});

return (_ctx: any,_cache: any) => {
  const _component_colorbar_horizontal = _resolveComponent("colorbar-horizontal")!
  const _component_colorbar = _resolveComponent("colorbar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.horizontal ? 'map-colorbar-wrap-horizontal' : 'map-colorbar-wrap'])
  }, [
    (__props.horizontal)
      ? (_openBlock(), _createBlock(_component_colorbar_horizontal, {
          key: 0,
          backgroundColor: "transparent",
          nsteps: 255,
          cmap: __props.currentColormap,
          cmapName: __props.colorMap,
          "start-value": __props.startValue,
          "end-value": __props.endValue,
          extend: true
        }, {
          label: _withCtx(() => [
            (scalePower.value !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _cache[4] || (_cache[4] = _createTextVNode(" Amount of ", -1)),
                  _createElementVNode("span", { innerHTML: __props.moleculeLabel }, null, 8, _hoisted_2),
                  _createElementVNode("span", _hoisted_3, [
                    _cache[0] || (_cache[0] = _createTextVNode("(10", -1)),
                    _createElementVNode("sup", null, _toDisplayString(scalePower.value), 1),
                    _cache[1] || (_cache[1] = _createTextVNode(" mol/cm", -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("sup", null, "2", -1)),
                    _cache[3] || (_cache[3] = _createTextVNode(")", -1))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Amount of ", -1)),
                  _createElementVNode("span", { innerHTML: __props.moleculeLabel }, null, 8, _hoisted_5),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "unit-label" }, [
                    _createTextVNode(" molecules/cm"),
                    _createElementVNode("sup", null, "2")
                  ], -1))
                ]))
          ]),
          _: 1
        }, 8, ["cmap", "cmapName", "start-value", "end-value"]))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default"),
    (!__props.horizontal)
      ? (_openBlock(), _createBlock(_component_colorbar, {
          key: 1,
          backgroundColor: "transparent",
          nsteps: 255,
          cmap: __props.currentColormap,
          cmapName: __props.colorMap,
          "start-value": __props.startValue,
          "end-value": __props.endValue,
          extend: true
        }, {
          label: _withCtx(() => [
            (scalePower.value !== 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _cache[11] || (_cache[11] = _createTextVNode(" Amount of ", -1)),
                  _createElementVNode("span", { innerHTML: __props.moleculeLabel }, null, 8, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, [
                    _cache[7] || (_cache[7] = _createTextVNode("(10", -1)),
                    _createElementVNode("sup", null, _toDisplayString(scalePower.value), 1),
                    _cache[8] || (_cache[8] = _createTextVNode(" mol/cm", -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("sup", null, "2", -1)),
                    _cache[10] || (_cache[10] = _createTextVNode(")", -1))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _cache[12] || (_cache[12] = _createTextVNode(" Amount of ", -1)),
                  _createElementVNode("span", { innerHTML: __props.moleculeLabel }, null, 8, _hoisted_10),
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "unit-label" }, [
                    _createTextVNode("(molecules/cm"),
                    _createElementVNode("sup", null, "2"),
                    _createTextVNode(")")
                  ], -1))
                ]))
          ]),
          _: 1
        }, 8, ["cmap", "cmapName", "start-value", "end-value"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})